// ordered alphabetically

export const CartEvents = {
  ACTIONS: {
    AAP: 'aap',
    GIFT: 'gift',
    PRIMARY: 'primary',
    SINGLE_CLASS: 'single-class',
  },
  EMAIL_GATHER: {
    ADDED_IN_ARTICLES_HERO: 'added_by_user_in_articles_hero',
    ADDED_IN_EMAIL_STEP: 'added_by_user_in_email_step',
    ADDED_IN_HP_HERO: 'added_by_user_in_home_hero',
    ADDED_IN_SESSIONS_HERO: 'added_by_user_in_sessions_home_hero',
    SKIPPED: 'skipped',
    USER_ADDED: 'user_added',
  },
  EVENTS: {
    ACCOUNT_CREATED: 'Account Created',
    BRAINTREE_CC_RENDERED: 'Braintree CC Rendered',
    CART_EMAIL_CAPTURED_GOLD_STANDARD: 'Cart Email Captured',
    CHECKOUT: 'Checkout',
    EXPERIMENT_VIEWED: 'Experiment Viewed',
    GIFT_PURCHASE_INFO_STEP: 'Gift Purchase Info Step',
    PAYMENT_FAILURE: 'Payment Failure',
    PAYPAL_SUB_CHECKOUT_INITIAL_FAILED:
      'PayPal Subscription Checkout Initialization Failed',
    PAYPAL_SUB_INITIAL_FAILED: 'PayPal Subscription Initialization Failed',
    PAYPAL_SUB_LOADING_FAILED: 'PayPal Subscription Loading Failed',
    PAYPAL_SUB_PAYMENT_AUTHORIZED: 'PayPal Subscription Payment Authorized',
    PAYPAL_SUB_PAYMENT_FAILED: 'PayPal Subscription Payment Failed',
    PURCHASE_CLICK: 'Purchase Click',
    PURCHASE_OPTIONS_CLICK: 'Purchase Options Click',
    REGISTRATION_SUCCESS: 'Cart Registration Successful',
    SAVE_CARD: 'Selected Save Card Details',
    SIGNED_IN: 'Signed In',
    SOCIAL_SIGN_UP_CLICKED: 'Social Sign Up Clicked',
  },
  PAGES: {
    CART: 'Cart',
    PURCHASE_OPTIONS: 'Purchase Options',
    REFERRAL: 'Referral Sources',
  },
} as const
